import React from 'react';
import { Link } from 'react-router-dom';

import {
  FaCalendar,
  FaDollarSign,
  FaIdCard,
  FaClipboard,
} from 'react-icons/fa';

import { Badge } from 'react-bootstrap';
import { useClinica } from '../../hooks/clinica';

import { ICartao } from '../PacienteCadastro';

import { Content } from './styles';

type AvatarProps = {
  codigo: number;
  nome: string;
  nomeSocial: string;
  avatar_url: string | undefined;
  cartao?: ICartao;
  pathAtivo: string;
  handleSelectPath(path: string): void;
};

const PacienteMenu: React.FC<AvatarProps> = ({
  nome,
  nomeSocial,
  codigo,
  avatar_url,
  cartao,
  pathAtivo,
  handleSelectPath,
}) => {
  const { imagensClinica } = useClinica();

  const semFoto =
    imagensClinica.find(img => img.nome === 'semFoto')?.arquivo_url || '';

  const avatarUrl = avatar_url && avatar_url.length > 10 ? avatar_url : semFoto;

  const corCartao = cartao && cartao.Status === 'Em Dia' ? 'primary' : 'danger';

  return (
    <Content>
      <div className="">
        <img
          src={avatarUrl}
          className="float-left rounded mr-2"
          style={{ width: '55px', maxHeight: '54px' }}
          alt={nome}
        />
        {nomeSocial?.trim() !== '' ? (
          <>
            <small className="text-muted">
              Nome Social:{' '}
              <h6 className="text-primary mb-0" style={{ display: 'contents' }}>
                {nomeSocial}
              </h6>
            </small>
            <br />
          </>
        ) : (
          <h6 className="text-primary mb-0">{nome}</h6>
        )}

        <small className="text-muted">
          Nº Registro: <b>{codigo}</b>
        </small>
        {cartao && (
          <>
            <div className={`alert alert-${corCartao} mb-0 small d-block mt-2`}>
              <Link
                to={`/cartaosaudedetalhe/${cartao.PlaCodigo}`}
                className={`d-flex justify-items-center text-${corCartao}`}
              >
                <FaIdCard size={13} className="mr-1" /> Cartão Saúde{' '}
                {cartao.Status}
              </Link>
            </div>

            {!cartao.PlaContratoAssinado && (
              <div
                style={{
                  height: '10px',
                  fontSize: '13px',
                  textAlign: 'center',
                }}
              >
                <Badge pill variant="warning">
                  Assinar Contrato
                </Badge>
              </div>
            )}
          </>
        )}
      </div>

      <div className="bg-white p-2 border rounded mt-2 w-100 d-inline-block">
        <nav className="list-group small">
          <button
            type="button"
            className={`list-group-item list-group-item-action ${
              pathAtivo === 'dados' ? 'active' : ''
            }`}
            onClick={() => handleSelectPath('dados')}
          >
            <FaIdCard size={13} /> Dados
          </button>
          <button
            type="button"
            className={`list-group-item list-group-item-action ${
              pathAtivo === 'historico' ? 'active' : ''
            }`}
            onClick={() => handleSelectPath('historico')}
          >
            <FaCalendar size={13} /> Histórico
          </button>
          {/* <Link
            to="Historico?PacCodigo"
            className="list-group-item list-group-item-action"
          >
            <FaInbox size={13} /> Anamnese
          </Link> */}
          <button
            type="button"
            className={`list-group-item list-group-item-action ${
              pathAtivo === 'pagamentos' ? 'active' : ''
            }`}
            onClick={() => handleSelectPath('pagamentos')}
          >
            <FaDollarSign size={13} /> Pagamentos
          </button>

          <button
            type="button"
            className={`list-group-item list-group-item-action ${
              pathAtivo === 'documentos' ? 'active' : ''
            }`}
            onClick={() => handleSelectPath('documentos')}
          >
            <FaClipboard size={13} /> Documentos
          </button>

          <button
            type="button"
            className={`list-group-item list-group-item-action ${
              pathAtivo === 'anexos' ? 'active' : ''
            }`}
            onClick={() => handleSelectPath('anexos')}
          >
            <FaClipboard size={13} /> Anexos
          </button>

          {/* <Link
            to="Documento?PacCodigo"
            className="list-group-item list-group-item-action"
          >
            <FaClipboard size={13} /> Documentos
          </Link> */}
          {/* <Link
            to="Anexo?PacCodigo"
            className="list-group-item list-group-item-action"
          >
            <FaClipboard size={13} /> Anexos
          </Link> */}
        </nav>
      </div>
      {/* <%Else If Tipo=2 then%>
<ul class="nav nav-tabs nav-fill nav-stacked well">
    <li class="nav-item"><a class="nav-link" href="Cadastro?PacCodigo=<%= PacCodigo%>" id="dados-tab"><i class="fa fa-id-card-o" aria-hidden="true"></i> Dados</a></li>
    <li class="nav-item"><a class="nav-link" href="Anamnese?PacCodigo=<%= PacCodigo%>" id="anamnese-tab"><i class="fa fa-inbox" aria-hidden="true"></i> Anamnese</a></li>
    <li class="nav-item"><a class="nav-link" href="Historico?PacCodigo=<%= PacCodigo%>" id="historico-tab"><i class="fa fa-calendar" aria-hidden="true"></i> Histórico</a></li>
    <%--<li class="nav-item"><a class="nav-link" href="ortodontiaorcamento?PacCodigo=<%= PacCodigo%>" id="ortodontiaorcamento1-tab"><i class="fa fa-microchip" aria-hidden="true"></i> Ortodontia</a></li>   --%>
</ul> */}
    </Content>
  );
};

export default PacienteMenu;
